/**
 * Столбец «ИНН / УНП» в «Счетах», «Открытой прибыли» и «Потенциале».
 *
 * Как и в «Оплатах», реквизит берётся только из 1С: бэкенд отдаёт поле INN —
 * `debitorzadolzh.inn` счёта без заглушек «0» и пустой строки. У российских
 * контрагентов там ИНН, у белорусских — УНП. В Excel столбец уходит текстом,
 * иначе ИНН с ведущими нулями потерял бы их.
 */
export const INN_COLUMN_KEY = "INN";

export function innColumn(extra = {}) {
  return { key: INN_COLUMN_KEY, title: "ИНН / УНП", active: true, exportAsText: true, ...extra };
}

/**
 * Дописывает в список колонки из reference, которых в нём нет.
 *
 * Каждая недостающая колонка встаёт сразу за ближайшим соседом слева по
 * умолчанию, а не в конец: у настроившего порядок столбцов новая колонка
 * иначе оказалась бы за двумя десятками других и не была бы видна. Так
 * обрабатываются сохранённый порядок колонок и сохранённые привязки,
 * записанные до появления колонки.
 */
export function placeMissingColumns(columns, reference) {
  const result = [...(Array.isArray(columns) ? columns : [])];
  const indexOf = key => result.findIndex(column => String(column.key) === String(key));

  reference.forEach((column, index) => {
    if (indexOf(column.key) !== -1) return;
    let position = 0;
    for (let left = index - 1; left >= 0; left--) {
      const at = indexOf(reference[left].key);
      if (at !== -1) {
        position = at + 1;
        break;
      }
    }
    result.splice(position, 0, { ...column });
  });

  return result;
}

/**
 * Переставляет columns под сохранённый order (ключи в желаемой
 * последовательности). Ключи, которых нет в order (колонки, появившиеся после
 * того как пользователь в последний раз менял порядок), встают за своим
 * соседом слева по умолчанию — см. placeMissingColumns.
 */
export function reorderColumns(columns, order) {
  if (!order || !order.length) return columns;

  const byKey = new Map(columns.map(column => [String(column.key), column]));
  const ordered = [];

  order.forEach(key => {
    const column = byKey.get(String(key));
    if (column) {
      ordered.push(column);
      byKey.delete(String(key));
    }
  });

  return placeMissingColumns(ordered, columns);
}
